import classNames from "classnames";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { ProfileExport } from "PFTypes";

// using format from EY, can be changed if requested
import { formatExperienceText } from "../../../../../ey/pptx/helpers";
import { ProfileExportFormatted } from "../../../../../types";
import { FullExperience, usePositionsByCategory } from "../../../../use_positions_by_category";
import mainCss from "../kpmg_au_pptx_preview.module.scss";
import css from "./positions.module.scss";

type PositionsProps = {
  internalExperiences?: ProfileExport["internal_experiences"];
  positions: ProfileExportFormatted["positions"];
  title: string;
};

export const Positions = ({ positions, internalExperiences, title }: PositionsProps) => {
  const { formatDate } = useDateFormatter();

  const positionsByCategory = usePositionsByCategory(positions, internalExperiences);

  const renderPositions = (positions: FullExperience[]) =>
    positions.map(({ id, internalExperiences, jobTitle, companyName, summary, startDate, endDate }) => (
      <div key={id}>
        <strong className={mainCss.text}>{`${companyName} - ${formatExperienceText(
          formatDate,
          jobTitle,
          startDate,
          endDate
        )}`}</strong>
        {(summary || internalExperiences) && (
          <div className={mainCss.text}>
            {summary && <span>{summary}</span>}
            {(internalExperiences || []).length > 0 && (
              <ul>
                {internalExperiences.map(({ name, description, metadata: { date_range } }) => (
                  <li key={name} className={classNames(css.internalExperience, mainCss.text)}>
                    <div>
                      {formatExperienceText(formatDate, name, date_range?.start_date, date_range?.end_date)}
                    </div>
                    {description && <div>{description}</div>}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    ));

  if (!positions?.items || positions.items.length === 0) {
    return null;
  }

  return (
    <div>
      <strong className={mainCss.header2}>{title}</strong>
      {positionsByCategory.map(([category, positions]) => (
        <div key={category.id}>
          <div className={classNames(mainCss.header2, mainCss.categoryHeader)}>{category.text}</div>
          <div className={css.positions}>{renderPositions(positions)}</div>
        </div>
      ))}
    </div>
  );
};
